import attribute from './attribute.js'

export default class parameter{
    constructor(attribute=null, field_type='dropdown'){

        this.field_type = field_type;
        this.attribute = attribute;
        this.values = [];
        this.title_show = false;

        this.value = '';
        this.field_under_label='',

        this.justifyContent = '',
        this.alignItems = '',
        this.otherclasses = '',
        this.title_show = false,
        this.title_width = '',
        this.title_size = '',
        this.field_show_cleanradiobuttons = false,
        this.wrap =false


    }
}